import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import { SelectFilters } from '@gef-ui/components/atoms/Select';
import CalendarIcon from '@gef-ui/material-icons/Calendar';
import { asDateModelParser } from '@gef-ui/redux-form/components/Field/fieldModelParsers';
import { routingSlice } from '@gef-ui/router-reactrouter6';
import { stateManagementSlice } from '@gef-ui/statemanagement-redux';

import Version from 'components/atoms/Version';
import { acceptedDateFormats, defaultDateFormat } from 'constants/general';
import PAGES from 'constants/pages';

const accessDeniedComponent = (
	<Alert sx={{ mb: 1, position: 'relative', zIndex: 0 }} severity="error">
		{'Nemáte přístup'}
	</Alert>
);

export default {
	props: {
		CduUser: {
			AccessControl: {
				showAccessDenied: false,
				accessDeniedComponent,
			},
		},
		Codelist: {
			AutoComplete: {
				oauth2: true,
			},
			CodelistContainer: {
				oauth2: true,
			},
		},
		Components: {
			DatePicker: {
				dateFormat: defaultDateFormat,
				placeholder: defaultDateFormat,
				showYearDropdown: true,
				maxLength: 10,
			},
			DatePickerFromTo: {
				dateFormat: defaultDateFormat,
				modelParser: asDateModelParser(acceptedDateFormats, defaultDateFormat),
				showYearDropdown: true,
			},
			Select: {
				autoComplete: 'off',
				filter: SelectFilters.caseInsensitive,
			},
			TextField: {
				autoComplete: 'off',
			},
			TextFieldComposer: {
				autoComplete: 'off',
			},
		},
		ErrorReportMaterial: {
			MuiModalMultipleErrors: {
				footer: (
					<Typography
						sx={{
							padding: 3,
						}}
					>
						<Version screenId={PAGES.errorReportAppBar.id} screenName={PAGES.errorReportAppBar.name} />
					</Typography>
				),
			},
		},
		VersionInfoCore: {
			useVersionInfo: {
				feEndpointMappingArray: [{ name: 'FE', endpoint: '/version.txt' }],
			},
		},
		FormMaterial: {
			Autocomplete: {
				valuePropName: 'id',
			},
			CodelistAutocomplete: {
				endpoint: '/code-table/:name',
			},
			DatePicker: {
				fullWidth: true,
				components: {
					OpenPickerIcon: CalendarIcon,
				},
			},
			TextField: {
				fullWidth: true,
				autoComplete: 'off',
			},
		},
	},
	routing: {
		Router: {
			...routingSlice.routing.Router,
		},
	},
	stateManagement: {
		...stateManagementSlice.stateManagement,
	},
};
